import React from 'react'
import { H1, LabeledCheckbox, Action } from '@zooz/generic-ui-components'
import { Language } from '@zooz/localize'

import language from './language'

import style from './NewLanguageMessage.scss'

export interface NewLanguageMessageProps {
  languages: Language[],
  newLanguagesCodes: string[],
  dismiss: () => void
}

const NewLanguageMessage: React.FC<NewLanguageMessageProps> = ({ languages, newLanguagesCodes, dismiss }) => {
  const newLanguagesNames = languages
    .filter(language => newLanguagesCodes.includes(language.code))
    .map(language => language.displayName)
  if (newLanguagesNames.length >= 2) {
    newLanguagesNames[newLanguagesNames.length - 2] += ` and ${newLanguagesNames.pop()}`
  }

  const numberOfNewLanguages = newLanguagesCodes.length
  return (
    <div data-test='new-language-message' className={style.NewLanguageMessage}>
      <H1
        type={H1.TYPES.PAGE_TITLE}
        className={style.NewLanguageMessage__header}
      >
        {language.header(numberOfNewLanguages)}
      </H1>
      {language.nowAvailable(newLanguagesNames)}
      <br />
      <br />
      <div>{ language.youCanChoose }</div>
      <div>{language.or}</div>
      <div>{ language.changeLater }</div>
      <div className={style.NewLanguageMessage__footer}>
        <div>
          <LabeledCheckbox className={style.NewLanguageMessage__footer__checkbox} onChange={dismiss}>
            <Action type={Action.TYPES.GHOST}>
              { language.dontShowAgain }
            </Action>
          </LabeledCheckbox>
        </div>
      </div>
    </div>
  )
}

export default NewLanguageMessage
